import { render, staticRenderFns } from "./ComponentCreatePropertyModal.vue?vue&type=template&id=670a2e63&"
import script from "./ComponentCreatePropertyModal.vue?vue&type=script&lang=js&"
export * from "./ComponentCreatePropertyModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentCreatePropertyModal.vue?vue&type=style&index=0&id=670a2e63&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670a2e63')) {
      api.createRecord('670a2e63', component.options)
    } else {
      api.reload('670a2e63', component.options)
    }
    module.hot.accept("./ComponentCreatePropertyModal.vue?vue&type=template&id=670a2e63&", function () {
      api.rerender('670a2e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ComponentCreatePropertyModal.vue"
export default component.exports